import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { Spinner } from '@/shared/components/spinner';
import { useRef, useState } from 'react';

interface AsyncButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  disabled?: boolean;
  isLoading?: boolean;
  variant?:
    | 'default'
    | 'destructive'
    | 'outline'
    | 'secondary'
    | 'ghost'
    | 'link';
}

export function AsyncButton({
  children,
  disabled,
  isLoading,
  onClick,
  className,
  variant = 'default',
  ...props
}: AsyncButtonProps) {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [buttonWidth, setButtonWidth] = useState<number | undefined>(
    undefined,
  );

  const clickHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    const currentButtonWidth = buttonRef.current?.offsetWidth;
    if (currentButtonWidth) setButtonWidth(currentButtonWidth);
    onClick?.(e);
  };

  return (
    <Button
      {...props}
      disabled={disabled || isLoading}
      onClick={clickHandler}
      className={cn(
        'cursor-pointer items-center justify-center',
        isLoading || disabled ? 'cursor-not-allowed opacity-50' : '',
        className,
      )}
      style={{
        minWidth: buttonWidth ? `${buttonWidth}px` : undefined,
      }}
      ref={buttonRef}
      variant={variant}
    >
      {isLoading ? (
        <Spinner className="size-5 min-w-5" />
      ) : (
        <div className="flex items-center gap-2">{children}</div>
      )}
    </Button>
  );
}
